import { z } from 'zod';

export const paginationQueryParams = z.object({
  page: z.nullable(z.number()),
  pageSize: z.nullable(z.number()),
});

export const paginationQueryResponse = z.object({
  page: z.nullable(z.number()),
  pageSize: z.nullable(z.number()),
  pageCount: z.nullable(z.number()),
  total: z.nullable(z.number()),
});

export type PaginationQueryParams = z.infer<typeof paginationQueryParams>;
export type PaginationType = z.infer<typeof paginationQueryResponse>;
